export default __webpack_public_path__ + "static/media/wooli.b7d513cb.png";